var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.menuItem.children)?_c('div',[_c('menu-item-group',{attrs:{"menuItem":_vm.menuItem}})],1):_c('div',[_c('menu-item-single',{attrs:{"menuItem":_vm.menuItem}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }